<template>
    <div v-if="!display.mobile"
         class="d-flex jusify-start align-items-start mt-4">
      <v-btn class="font-weight-bold text-primary bg-secondary"
             :variant="variant"
             :density="density"
             :size="size"
             :to="to">{{ actionButtonText }}</v-btn>
    </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { useDisplay } from 'vuetify';

defineProps({
  actionButtonText: {
    type: String,
    default: 'Schedule your consultation',
  },
  variant: {
    type: String as PropType< "text" | "flat" | "elevated" | "tonal" | "outlined" | "plain">,
    default: 'elevated',
  },
  density: {
    type: String as PropType<"default" | "comfortable" | "compact">,
    default: 'default',
  },
  size: {
    type: String as PropType<"default" | "small" | "medium" | "large" | "x-large">,
    default: 'large',
  },
  to: {
    type: String,
    default: '#contact-form',
  },
});
const display = ref(useDisplay());
</script>

<style>

</style>